module.exports = __webpack_public_path__ + "images/emoji/car.567150e37f31b13b2c75.png";